import DG from '2gis-maps';

export default function (element, data) {
    DG.then(function() {
        var map = DG.map(element, {
            'center': [54.98, 82.89],
            'zoom': 13
        });

        const markers = DG.featureGroup();

        for (const branch of data.branches) {
            const coords = branch.coord.split(",").map((v) => parseFloat(v.trim()));

            DG.marker(coords).addTo(markers).bindPopup(branch.description);
        }
        
        map.fitBounds(markers.getBounds(), {
            maxZoom: 17
        });
        markers.addTo(map);

        let oldLatLng = null;
        let oldZoom = null;
        markers.on('popupopen', function(e) {
            oldLatLng = map.getCenter();
            oldZoom = map.getZoom();
            map.setView(e.popup._latlng, 17);
        });

        markers.on('popupclose', function(e) {
            map.setView(oldLatLng, oldZoom);
        });
    });
}

// @widgetLoadingMode:lazy-once